export default function ErrorComponent() {
    return(
        <div> Error </div>
    )
}
